export default __webpack_public_path__ + "static/media/2023_Januar_Bach.02482d30.webp";